"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OTHER = exports.INCORPORATED_BUSINESS = exports.UNINCORPORATED_BUSINESS = exports.SOLE_PROPRIETOR = exports.PARTNERSHIP = exports.LIMITED_LIABILITY_PARTNERSHIP = exports.LIMITED_LIABILITY_COMPANY = exports.JOINT_VENTURE = void 0;
var JOINT_VENTURE = 'joint_venture';
exports.JOINT_VENTURE = JOINT_VENTURE;
var LIMITED_LIABILITY_COMPANY = 'limited_liability_company';
exports.LIMITED_LIABILITY_COMPANY = LIMITED_LIABILITY_COMPANY;
var LIMITED_LIABILITY_PARTNERSHIP = 'limited_liability_partnership';
exports.LIMITED_LIABILITY_PARTNERSHIP = LIMITED_LIABILITY_PARTNERSHIP;
var PARTNERSHIP = 'partnership';
exports.PARTNERSHIP = PARTNERSHIP;
var SOLE_PROPRIETOR = 'sole_proprietor';
exports.SOLE_PROPRIETOR = SOLE_PROPRIETOR;
var UNINCORPORATED_BUSINESS = 'unincorporated_business';
exports.UNINCORPORATED_BUSINESS = UNINCORPORATED_BUSINESS;
var INCORPORATED_BUSINESS = 'incorporated_business';
exports.INCORPORATED_BUSINESS = INCORPORATED_BUSINESS;
var OTHER = 'other';
exports.OTHER = OTHER;